import { Component, Input, OnInit, SimpleChanges } from '@angular/core';
import { AbstractControl, FormControl, Validators } from '@angular/forms';
import { MatAutocompleteSelectedEvent } from '@angular/material/autocomplete';
import { OptionsAutocomplete } from 'src/app/core/interfaces/optionsAutocomplete';
import { UserClient } from 'src/app/core/interfaces/userClient';
import { Utils } from 'src/app/core/resources/utils';
import { AdminUsersService } from 'src/app/modules/administration/admin-users/admin-users.service';

@Component({
  selector: 'app-autocomplete-user-client',
  templateUrl: './autocomplete-user-client.component.html',
  styleUrls: ['./autocomplete-user-client.component.scss']
})
export class AutocompleteUserClientComponent implements OnInit {

  @Input() options: OptionsAutocomplete;
  @Input() inputFormControl: FormControl;
  @Input() validate: string = '';
  loadingUsers: boolean = false;

  formControlUserClient: FormControl = new FormControl();
  listUsersClient: UserClient[] = [];

  private readonly maxVisibleOptions: number = 5;

  constructor(
    private adminUsersService: AdminUsersService,
    public utils: Utils
  ) { }

  async ngOnInit() {
    const validator = this.inputFormControl && this.inputFormControl.validator ? this.inputFormControl.validator({} as AbstractControl) : '';
    if (validator && validator.required) this.formControlUserClient.setValidators(Validators.required);
    if (!this.listUsersClient.length) await this.getUsersClient();
  }

  async getUsersClient() {
    this.loadingUsers = true;
    try {
      const response = await this.adminUsersService.getUsersList('userClient').toPromise();
      this.listUsersClient = (response as UserClient[]) || [];
      this.loadingUsers = false;
    } catch (error) {
      this.loadingUsers = false;
      this.listUsersClient = [];
      console.error('Error loading users client for autocomplete:', error);
    }
  }

  displayUserClientName(userClient?: any): string | undefined {
    if (!userClient) return undefined;
    return (userClient.information && userClient.information.name) || undefined;
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (changes.options && changes.options.currentValue) {
        if (changes.options.currentValue.initialValue || changes.options.currentValue.initialValue === "") {
          changes.options.currentValue.initialValue
            ? this.setInitialUserClient(changes.options.currentValue.initialValue)
            : this.formControlUserClient.setValue("");
          if (this.options && this.options.showXMark && !changes.options.currentValue.initialValue)
            this.formControlUserClient.enable();
        }
      }

      if (changes.validate) {
        switch (this.validate) {
          case 'touched':
            this.formControlUserClient.markAsTouched();
            break;
          case 'untouched':
            this.formControlUserClient.markAsUntouched();
            break;
          case 'enable':
            this.formControlUserClient.enable();
            break;
          case 'disable':
            this.formControlUserClient.disable();
            break;
          case 'disable&untouched':
            this.formControlUserClient.markAsUntouched();
            this.formControlUserClient.disable();
            break;
          case 'setValidators':
            this.formControlUserClient.setValidators(Validators.required);
            this.formControlUserClient.updateValueAndValidity();
            break;
          case 'clearValidators':
            this.formControlUserClient.clearValidators();
            this.formControlUserClient.updateValueAndValidity();
            break;
          default:
            break;
        }
      }
    }
  }

  async setInitialUserClient(value: string) {
    if (!this.listUsersClient.length) await this.getUsersClient();
    const userClient = this.listUsersClient.find((user) =>
      (user.information && user.information.document === value.toString())
    );
    if (userClient) {
      this.formControlUserClient.setValue(userClient);
      this.inputFormControl.setValue(userClient);
      if (this.options && this.options.showXMark) this.formControlUserClient.disable();
    }
  }

  onSelectUserClient($event: MatAutocompleteSelectedEvent) {
    if ($event && $event.option && $event.option.value && this.inputFormControl) {
      this.inputFormControl.setValue($event.option.value);
      if (this.options && this.options.showXMark) this.formControlUserClient.disable();
    }
  }

  cleanFieldUserClient() {
    this.formControlUserClient.setValue('');
    this.inputFormControl.setValue('');
    this.formControlUserClient.enable();
  }

  changeValue() {
    if (this.inputFormControl) this.inputFormControl.setValue("");
  }

  get usersClientFiltered(): UserClient[] {
    const value: UserClient | string = this.formControlUserClient.value;
    const term = typeof value === 'string'
      ? value
      : (value && value.information && value.information.name ? value.information.name : '');

    if (!term) return this.listUsersClient.slice(0, this.maxVisibleOptions);

    return this.listUsersClient.filter(user =>
      user && user.information && user.information.name &&
      user.information.name.toLowerCase().includes(term.toLowerCase())
    ).slice(0, this.maxVisibleOptions);
  }
}
